const LAMBDA_BASE_URL = process.env.REACT_APP_LAMBDA_URL || 'https://jme2stal2d.execute-api.us-east-1.amazonaws.com/prod';
const API_KEY = process.env.REACT_APP_API_KEY || 'SV2YyNiwtD1L7MzqgWrfk2WqhZgXSu6086eItWWg';

const handleLambdaResponse = async (response) => {
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Network error' }));
    throw new Error(error.error || `HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const uploadPOD = async (file, onProgress) => {
  try {
    // Convert file to base64
    const fileData = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result.split(',')[1];
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

    const payload = {
      httpMethod: 'POST',
      fileName: file.name,
      fileData: fileData,
      contentType: file.type
    };

    const response = await fetch(`${LAMBDA_BASE_URL}/upload-pod`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': API_KEY
      },
      body: JSON.stringify(payload),
      redirect: 'follow'
    });
    return await handleLambdaResponse(response);
  } catch (error) {
  }
};

export const getPODById = async (id) => {
  try {
    const response = await fetch(`${LAMBDA_BASE_URL}/get-pod/${encodeURIComponent(id)}`, {
      headers: {
        'x-api-key': API_KEY
      }
    });
    const result = await handleLambdaResponse(response);
    console.log('Lambda get POD by ID result:', result);
    return JSON.parse(result.body);
  } catch (error) {
    console.error('Lambda get POD by ID error:', error);
    throw new Error('Failed to get POD by ID via Lambda');
  }
};